import { cn } from "@/lib/cn";
import { useSession } from "@/components/providers/session-provider";
import { useRegistrations } from "@/components/providers/registrations-provider";
import { BOTTOM_NAV, isActive, resolveHref, type NavItem } from "./nav-config";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export function BottomNav() {
  const { me } = useSession();
  const { activeSlug, registrations } = useRegistrations();
  const { pathname } = useLocation();

  if (me?.authenticated !== true) return null;

  const rows = BOTTOM_NAV.filter(
    (item) => !item.requiresRegistration || registrations.length > 0,
  )
    .map((item) => ({
      item,
      href: resolveHref(item, activeSlug),
    }))
    .filter((r): r is { item: NavItem; href: string } => r.href !== null);

  return (
    <nav
      className="glass no-print fixed inset-x-0 bottom-0 z-40 min-h-[4.5rem] border-t border-border pb-[env(safe-area-inset-bottom)] lg:hidden"
      aria-label="Bottom navigation"
    >
      <div className="mx-auto flex max-w-lg items-stretch justify-around px-1">
        {rows.map(({ item, href }) => {
          const active = isActive(href, pathname, item.exact, item.activePrefixes);
          const Icon = item.icon;
          return (
            <Link
              key={href}
              to={href}
              aria-current={active ? "page" : undefined}
              className="group relative flex flex-1 flex-col items-center gap-1 py-2.5"
            >
              <span
                className={cn(
                  "flex h-8 w-12 items-center justify-center rounded-full transition-all duration-200",
                  active
                    ? "bg-[var(--brand-accent)]/12 text-[var(--brand-accent)]"
                    : "text-text-subtle group-hover:text-text-muted",
                )}
              >
                <Icon className="h-[18px] w-[18px]" />
              </span>
              <span
                className={cn(
                  "text-[10px] font-semibold leading-none transition-colors",
                  active ? "text-[var(--brand-accent)]" : "text-text-subtle",
                )}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
